import "../css/bookclosure.css";
import commoncss from "../css/common.module.css";
import buttoncss from "../css/button.module.css";
import modalcss from "../css/modal.module.css";
import bookclosurecss from "../css/bookclosure.module.css";
import { useEffect, useState, useRef } from "react";
import SideMenu from "../elements/SideMenu";
import { DisplayCard } from "../elements/DisplayCards";
import PaginationFooter from "./../elements/PaginationFooter";
import StatusIndicator from "../elements/StatusIndicator";
import { Button } from "../elements/Button";
import BookClosureTable from "../elements/BookClosureTable";
import ToggleButton from "../elements/ToggleButton";
import OpenTaskImg from "../assets/imgs/open-tasks.png";
import InProgressImg from "../assets/imgs/book-closure-inprogress.png";
import CompletedImg from "../assets/imgs/book-closure-completed.png";
import { ReactComponent as DownArrowIcon } from "../assets/icons/down-arrow.svg";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../assets/icons/plusprimary.svg";
import { ReactComponent as CommentsActiveIcon } from "../assets/icons/comments_active.svg";
import AddTBModal from "../components/bookclosure/AddTBModal";
import PullTBfromERPModal from "../components/bookclosure/PullTBfromERPModal";
import COAModal from "../components/bookclosure/SelectCOAModal";
import AddTaskModal from "../components/bookclosure/AddTaskModal";
import AddNewTaskModal from "../components/bookclosure/AddNewTaskModal";
import UploadTBModal from "../components/bookclosure/UploadTBModal";
import SuccessModal from "../components/connections/SuccessModal";

const BookClosure = () => {
  const [displayModal, setDisplayModal] = useState(false);
  const [coaModal, setCOAModal] = useState(false);
  const [addTBModal, setAddTBModal] = useState(false);
  const [uploadTBModal, setUploadTBModal] = useState(false);
  const [pullTBfromERPModal, setPullTBfromERPModal] = useState(false);
  const [addTaskModal, setAddTaskModal] = useState(false);
  const [addNewTaskModal, setAddNewTaskModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [successModal, setSuccessModal] = useState(false);

  const menuItems = [
    { label: "Overview", link: "/myfinv2/" },
    { label: "Book Closures", link: "/myfinv2/book-closure" },
    { label: "Standalone", link: "/myfinv2/" },
    { label: "Consolidation", link: "/myfinv2/" },
    { label: "Team Members", link: "/myfinv2/" },
    { label: "Workspace Settings", link: "/myfinv2/" },
  ];

  const moduleLibrary = () => {
    window.location.href = "/myfinv2/book-closure/modules-library";
  };

  const redirectToComments = () => {
    window.location.href = "/myfinV2/book-closure/comments";
  };

  const importPresets = () => {
    window.location.href = "/myfinv2/book-closure/import-presets";
  };

  const fscpPostings = () => {
    window.location.href = "/myfinv2/book-closure/fscp-posting-view";
  };

  const bookclousreTB = () => {
    window.location.href = "/myfinv2/book-closure/tb";
  };

  const statusMap = {
    C: "Completed",
    I: "In Progress",
    S: "Submitted",
    O: "Open",
    D: "Over Due",
    R: "Returned",
  };

  const tableHeaders = {
    taskTemplateName: "Task / Template Name",
    module: "Module",
    assignee: "Assignee",
    approver: "Approver",
    dueDate: "Due Date",
    status: "Status",
    addColumn : (
      <>
      <span className={commoncss.plusActionBnt}>
        <PlusPrimaryIcon />&ensp;Add Column</span>
      </>
    ),
  };

  const rowData = [
    {
      task: "Task Consol FS",
      module: "CONSOLIDATION",
      assignee: ["User 1"],
      approver: "Username",
      due: "12-04-2024",
      status: <StatusIndicator status={statusMap["C"]} />,
      addColumn:""
    },
    {
      task: "Documenting fund statements for investments",
      module: "INVESTMENTS",
      assignee: ["User 2", "User 3"],
      approver: "Username",
      due: "15-04-2024",
      status: <StatusIndicator status={statusMap["I"]} />,
      addColumn:""
    },
    {
      task: "Documenting fund statements for investments",
      module: "INVESTMENTS",
      assignee: ["User 2", "User 3"],
      approver: "Username",
      due: "15-04-2024",
      status: <StatusIndicator status={statusMap["S"]} />,
      addColumn:""
    },
    {
      task: "Documenting fund statements for investments",
      module: "INVESTMENTS",
      assignee: ["User 2", "User 3"],
      approver: "Username",
      due: "15-04-2024",
      status: <StatusIndicator status={statusMap["O"]} />,
      addColumn:""
    },
    {
      task: "Documenting fund statements for investments",
      module: "INVESTMENTS",
      assignee: ["User 2", "User 3"],
      approver: "Username",
      due: "15-04-2024",
      status: <StatusIndicator status={statusMap["D"]} />,
      addColumn:""
    },
    {
      task: "Documenting fund statements for investments",
      module: "INVESTMENTS",
      assignee: ["User 2", "User 3"],
      approver: "Username",
      due: "15-04-2024",
      status: <StatusIndicator status={statusMap["R"]} />,
      addColumn:""
    },
  ];

  const columnClasses = {
    module: "bkclTableBoldTd",
    task: "bkclTableTemplateNameTd",
  };

  const headerClasses = {
    taskTemplateName: "bkclTableTemplateNameTh",
  };

  const handleClose = () => {
    setDisplayModal(false);
  };

  return (
    <div className="book-closure-page">
      <SideMenu
        title="Base - Base Corporation"
        menuItems={menuItems}
        activeItem="Book Closures"
      />
      <div className="book-closure-content">
        <div className="book-closure-header">
          <div className="header-content">
            <DownArrowIcon width={24} height={24} />
            <span className="header-title-bookclosure">Base Corp 123</span>
            <Button
              btnColor={buttoncss.secondary}
              icon={<CommentsActiveIcon />}
              label="Comments"
              onClick={redirectToComments}
            />
            <Button
              btnColor={buttoncss.secondary}
              label="Import Presets"
              onClick={importPresets}
            />
            <Button
              btnColor={buttoncss.primary}
              label="Import Tasks"
              onClick={moduleLibrary}
            />
          </div>
        </div>
        <div className="book-closure-data">
          <DisplayCard label="OPEN TASKS" value="25" image={OpenTaskImg} />
          <DisplayCard label="IN PROGRESS" value="12" image={InProgressImg} />
          <DisplayCard label="COMPLETED" value="34%" image={CompletedImg} />
          <div className="table-container-book-closure">
            <div className="filters-header">
              <span className="bkcl-tb-header">Book Closure Activities</span>
              <FilterIcon width={20} height={20} />
              <span>
                <ToggleButton label="View my tasks" onToggle={() => {}} />
              </span>
              <Button
                btnColor={buttoncss.secondary}
                label="Sync with ERP"
                onClick={() => {
                  setDisplayModal(true);
                  setSuccessMessage("Sync Initiated Successfully");
                  setSuccessModal(true);
                }}
              />
              <Button
                btnColor={buttoncss.secondary}
                label="View FSCP posting"
                onClick={fscpPostings}
              />
              <Button
                btnColor={buttoncss.secondary}
                label="Add TB"
                onClick={() => {
                  setDisplayModal(true);
                  setAddTBModal(true);
                }}
              />
              <Button
                icon={<PlusIcon />}
                btnColor={buttoncss.primary}
                label="Add task"
                onClick={() => {
                  setAddTaskModal(true);
                  setDisplayModal(true);
                }}
              />
            </div>
            <BookClosureTable
              tableHeaders={tableHeaders}
              rowData={rowData}
              columnClasses={columnClasses}
              headerClasses={headerClasses}
            />
          </div>
          {/* <PaginationFooter /> */}
          {addTaskModal && displayModal && (
            <AddTaskModal
              handleClose={handleClose}
              setAddTaskModal={setAddTaskModal}
              setAddNewTaskModal={setAddNewTaskModal}
            />
          )}

          {addNewTaskModal && displayModal && (
            <AddNewTaskModal
              handleClose={handleClose}
              setAddTaskModal={setAddTaskModal}
              setAddNewTaskModal={setAddNewTaskModal}
            />
          )}

          {addTBModal && displayModal && (
            <AddTBModal
              setUploadTBModal={setUploadTBModal}
              handleClose={handleClose}
              setAddTBModal={setAddTBModal}
              setPullTBfromERPModal={setPullTBfromERPModal}
            />
          )}
          {uploadTBModal && displayModal && (
            <UploadTBModal
              handleClose={handleClose}
              setUploadTBModal={setUploadTBModal}
            />
          )}
          {coaModal && displayModal && (
            <COAModal
              handleClose={handleClose}
              setAddTBModal={setAddTBModal}
              setPullTBfromERPModal={setPullTBfromERPModal}
              setCOAModal={setCOAModal}
            />
          )}
          {pullTBfromERPModal && displayModal && (
            <PullTBfromERPModal
              handleClose={handleClose}
              setAddTBModal={setAddTBModal}
              setPullTBfromERPModal={setPullTBfromERPModal}
              setCOAModal={setCOAModal}
            />
          )}
          {coaModal && displayModal && (
            <COAModal
              handleClose={handleClose}
              setAddTBModal={setAddTBModal}
              setPullTBfromERPModal={setPullTBfromERPModal}
              setCOAModal={setCOAModal}
            />
          )}
          {successModal && displayModal && (
                    <SuccessModal
                      handleClose={handleClose}
                      setSuccessModal={setSuccessModal}
                      setSuccessMessage={setSuccessMessage}
                      successMessage={successMessage}
                      bodycls={modalcss.successBody}
                    />
                  )}
        </div>
      </div>
    </div>
  );
};

export default BookClosure;
